import UserPreferenceModel from '../models/UserPreferenceModel';
import BaseStore from './BaseStore';

export default class UserPreferenceStore extends BaseStore {

  constructor(transportLayer) {
    super(UserPreferenceModel, transportLayer);
  }

}



// WEBPACK FOOTER //
// ./src/stores/UserPreferenceStore.js